import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/authContext';
import Dashboard from './SideBar';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { db } from '../firebase/firebase';
import "react-big-calendar/lib/css/react-big-calendar.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faSquareCaretLeft,
    faSquareCaretRight,
} from "@fortawesome/free-solid-svg-icons";
import {useDarkMode} from "../contexts/darkModeContext";
import MonthView from "./Calendar/MonthView";
import EventCard from "./Calendar/EventCard";


const localizer = momentLocalizer(moment)


const MyCalendar = () => {
    const { currentUser } = useAuth();

    const { darkMode } = useDarkMode();

    const [sprays, setSprays] = useState([]);
    const [services, setServices] = useState([]);
    const [purchase, setPurchase] = useState([]);
    const [employee, setEmployee] = useState([]);

    const [outings, setOutings] = useState([]);
    const [delivery, setDelivery] = useState([]);
    const [off, setOff] = useState([]);
    const [holiday, setHoliday] = useState([]);


    const [events, setEvents] = useState([]);

    const [editingId, setEditingId] = useState(null);

    const [formData, setFormData] = useState({
        name: '',
        date: '',
        type: '',
        notes: '',
     });

    const fillFormWithEventData = (event) => {
        setFormData({
            name: event.name,
            date: event.date,
            type: event.type,
            notes: event.notes,
        });
        setEditingId(event.id);
    };

    const clearForm = () => {
        setFormData({
            name: '',
            date: '',
            type: '',
            notes: '',
        });
        setEditingId(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const deleteFromFirestore = async (eventID) => {
        try {
            await db.collection('Users').doc(currentUser.uid).collection('events').doc(eventID).delete();
            console.log('Event item deleted successfully');
            // await onUpdate()
        } catch (error) {
            console.error('Error deleting event item:', error);
        }
    };

    const addOrUpdateButtonText = editingId ? 'Update Event' : 'Add Event';

    const currentDate = new Date().toLocaleDateString('en-US').split('/').join('-');

    const handleSubmit = async (e) => {
        e.preventDefault();
        const collectionRef = db.collection('Users').doc(currentUser.uid).collection('events');

        // If date field is empty, set it to the current date
        const currentDate = new Date().toLocaleDateString('en-US').split('/').join('-');
        const formDataWithDate = {
            ...formData,
            date: formData.date || currentDate
        };

        try {
            if (editingId) {
                await collectionRef.doc(editingId).update(formDataWithDate);
                console.log('Event updated successfully!');
                // await onUpdate();
            } else {
                await collectionRef.add(formDataWithDate);
                console.log('Event added successfully!');
                // await onUpdate();
            }

            clearForm(); // Clear the form after submission
        } catch (error) {
            console.error('Error adding/updating Event: ', error);
        }
    };



    // Fetch events from Firebase
    useEffect(() => {
        const fetchSprays = async () => {
            if (currentUser) {
                try {
                    const spraysCollectionRef = db.collection('Users').doc(currentUser.uid).collection('sprays');
                    const snapshot = await spraysCollectionRef.get();

                    if (!snapshot.empty) {
                        const sprayEvents = snapshot.docs.map(doc => {
                            const sprayData = doc.data();
                            return {
                                title: sprayData.name + "",
                                start: new Date(sprayData.date),
                                end: new Date(sprayData.date), // Assuming event is just a point in time
                            };
                        });
                        setSprays(sprayEvents);
                        console.log("Fetched sprays:", sprayEvents); // Log fetched events
                    } else {
                        console.log('No sprays found');
                    }
                } catch (error) {
                    console.error('Error fetching sprays:', error);
                }
            }
        };

        const fetchEvents = async () => {
            if (currentUser) {
                try {
                    const CollectionRef = db.collection('Users').doc(currentUser.uid).collection('events');
                    const snapshot = await CollectionRef.get();

                    if (!snapshot.empty) {


                        const Outings = snapshot.docs.map(doc => {
                            const data = doc.data();
                            if (data.type === "Outing") {
                                return {
                                    title: data.name,
                                    start: new Date(data.date),
                                    end: new Date(data.date), // Assuming event is just a point in time
                                };
                            }
                            return null; // If event is not of type "outings", return null
                        }).filter(event => event !== null); // Filter out null values
                        setOutings(Outings);

                        const Delivery = snapshot.docs.map(doc => {
                            const data = doc.data();
                            if (data.type === "Delivery") {
                                return {
                                    title: data.name,
                                    start: new Date(data.date),
                                    end: new Date(data.date), // Assuming event is just a point in time
                                };
                            }
                            return null; // If event is not of type "outings", return null
                        }).filter(event => event !== null); // Filter out null values
                        setDelivery(Delivery);

                        const Off = snapshot.docs.map(doc => {
                            const data = doc.data();
                            if (data.type === "Day Off") {
                                return {
                                    title: data.name,
                                    start: new Date(data.date),
                                    end: new Date(data.date), // Assuming event is just a point in time
                                };
                            }
                            return null; // If event is not of type "outings", return null
                        }).filter(event => event !== null); // Filter out null values
                        setOff(Off);

                        const Holiday = snapshot.docs.map(doc => {
                            const data = doc.data();
                            if (data.type === "Holiday") {
                                return {
                                    title: data.name,
                                    start: new Date(data.date),
                                    end: new Date(data.date), // Assuming event is just a point in time
                                };
                            }
                            return null; // If event is not of type "outings", return null
                        }).filter(event => event !== null); // Filter out null values
                        setHoliday(Holiday);



                        const Data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                        setEvents(Data);



                        console.log("Fetched events:", Outings); // Log fetched events
                    } else {
                        console.log('No events found');
                    }
                } catch (error) {
                    console.error('Error fetching events:', error);
                }
            }
        };

        const fetchServices = async () => {
            try {
                const servicesCollectionRef = db.collection('Users').doc(currentUser.uid).collection('fleet');
                const snapshot = await servicesCollectionRef.get();

                if (!snapshot.empty) {
                    const purchase = snapshot.docs.map(doc => {
                        const machineData = doc.data();
                        return {
                            title: machineData.name + " Purchased! Cost:[$" + machineData.purchasePrice + "]",
                            start: new Date(machineData.purchaseDate),
                            end: new Date(machineData.purchaseDate), // Assuming event is just a point in time
                        };
                    });
                    setPurchase(purchase);

                    const serviceData = [];
                    snapshot.docs.forEach(doc => {
                        const machineData = doc.data();
                        const machineName = machineData.name; // Accessing the machine name
                        machineData.service.forEach(service => { // Iterate over each service
                            const eventTitle = `${machineName} [${service.serviceType}]`;
                            serviceData.push({
                                title: eventTitle,
                                start: new Date(service.serviceDate),
                                end: new Date(service.serviceDate),
                            });
                        });
                    });
                    setServices(serviceData);
                    console.log("Fetched services:", serviceData); // Log fetched events
                } else {
                    console.log('No services found');
                }
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        };

        const fetchTeam = async () => {
            if (currentUser) {
                try {
                    const teamCollectionRef = db.collection('Users').doc(currentUser.uid).collection('team');
                    const snapshot = await teamCollectionRef.get();

                    if (!snapshot.empty) {
                        const employeeEvents = snapshot.docs.map(doc => {
                            const employeeData = doc.data();
                            return {
                                title: employeeData.name + " Hired!",
                                start: new Date(employeeData.startDate),
                                end: new Date(employeeData.startDate), // Assuming event is just a point in time
                            };
                        });
                        setEmployee(employeeEvents);
                        console.log("Fetched employees:", employeeEvents); // Log fetched events
                    } else {
                        console.log('No employees found');
                    }
                } catch (error) {
                    console.error('Error fetching employees:', error);
                }
            }
        };




        fetchSprays();
        fetchServices();
        fetchTeam();
        fetchEvents()
    }, [currentUser]);

    const allEvents = [
        ...sprays.map(event => ({ ...event, source: 'sprays' })),
        ...services.map(event => ({ ...event, source: 'services' })),
        ...purchase.map(event => ({ ...event, source: 'purchase' })),
        ...employee.map(event => ({ ...event, source: 'employee' })),

        ...outings.map(event => ({ ...event, source: 'outings' })),
        ...delivery.map(event => ({ ...event, source: 'delivery' })),
        ...off.map(event => ({ ...event, source: 'off' })),
        ...holiday.map(event => ({ ...event, source: 'holiday' })),

    ];

    console.log(allEvents);

    // eventStyleGetter function to assign different colors based on event source
    const eventPropGetter = event => {
        let backgroundColor;

        // Check the source of the event
        if (event.source === 'sprays') {
            backgroundColor = '#5C6784';
        } else if (event.source === 'services') {
            backgroundColor = '#147E1F';
        }else if (event.source === 'purchase') {
            backgroundColor = '#4BB862';
        }else if (event.source === 'employee') {
            backgroundColor = '#FFA000';
        }else if (event.source === 'outings') {
            backgroundColor = '#B91C1C';
        }else if (event.source === 'delivery') {
            backgroundColor = '#FFC300';
        }else if (event.source === 'off') {
            backgroundColor = '#008080';
        }else if (event.source === 'holiday') {
            backgroundColor = '#FF69B4';
        }else {
            backgroundColor = '#999999';
        }

        // Return an object with style properties
        return { style: { backgroundColor } };
    };


    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };



    return (
        <div className={`flex p-3 w-full h-full`}>

            <div className="w-full z-20 h-full animate-fadeIn">

                <MonthView/>

            </div>

        </div>
    );
};

export default MyCalendar;

